import React from 'react';

import Confluencelogo from '../../images/confluence.svg';

export const ConfluenceLogo = () => {
  return <img height="18" src={Confluencelogo} alt="Confluence logo" />;
};
